<template>
  <MqResponsive target="xs-md">
    <div class="block text-center" style="width: 100%; margin-top: 60px">
      <el-carousel
        height="auto"
        autoplay
        style="width: 100%"
        indicator-position="none"
      >
        <el-carousel-item style="min-height: 113px; width: 100%">
          <img
            src="@/assets/chaojiao/banner1.jpg"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
      <!--  -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">SEILECTED ARTICLES</span>
          <div class="line"></div>
        </div>
        <el-row
          :gutter="20"
          style="
            display: flex;
            justify-content: space-around;
            width: 100%;
            margin: 0;
          "
        >
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
          <el-col
            :span="8"
            style="background: #0f0f0f; padding: 10px 0 0; max-width: 30%"
          >
            <div
              style="
                padding: 6px 0;
                background: rgb(206, 2, 3);
                width: 130px;
                font-size: 18px;
                border-radius: 5px;
                text-align: center;
                margin: 0 auto;
              "
            >
              新闻资讯
            </div>
            <div style="font-size: 9px; margin: 5px 0 20px">
              頎心掮觴果内外重大财经新闻
            </div>
            <img
              src="@/assets/12.jpg"
              alt=""
              class="banner-image"
              style="width: 100%"
            />
            <el-button
              type="danger"
              size="large"
              style="
                background: #ce0203;
                border: #ce0203;
                --el-button-size: 23px;
                font-size: 12px;
                margin-left: 10px;
                margin-top: 20px;
                margin-bottom: 30px;
              "
              >查看更多 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!-- 交易学院 -->
      <div style="min-width: 412px; color: #fff; margin-top: 20px">
        <div>
          <div style="font-size: 30px">交易学院</div>
          <span style="font-size: 12px">EXCHANGE SCHOOL</span>
          <div class="line"></div>
        </div>

        <el-row :gutter="10" style="margin-bottom: 20px">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  基础知识
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                交易术语、流程等
              </div>
            </div>

            <img
              src="@/assets/技术分析.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  技术分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                指标、图表形态讲解
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 0px">
                  基本面分析
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                鷓玘蘺仞Ç喂济数据、政治事件影响
              </div>
            </div>

            <img
              src="@/assets/基础知识.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  交易策略
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                不同风格和风险偏好的策略分享
              </div>
            </div>

            <img
              src="@/assets/即时交易策略.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              padding: 50px 0 50px 10px;
              display: flex;
              align-items: center;
              margin: 0 0;
            "
          >
            <div>
              <div style="display: flex; align-items: center">
                <h1 style="color: #cd0104">|</h1>
                <div style="font-size: 50px; letter-spacing: 11px">
                  视频教学
                </div>
              </div>
              <div style="text-align: left; margin-left: 12px">
                实战演示和讲解
              </div>
            </div>

            <img
              src="@/assets/视频教学.png"
              style="width: 100px"
              alt=""
              class="banner-image"
            />
          </el-col>
          <el-col
            :xs="4"
            :sm="6"
            :md="8"
            :lg="9"
            :xl="8"
            style="
              background: #0f0f0f;
              min-width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <div text-align:center>期待更多...</div>
          </el-col>
        </el-row>
      </div>
      <!-- 交易大赛 -->
      <div
        style="
          min-width: 412px;
          color: #fff;
          margin-top: 20px;
          box-sizing: border-box;
        "
      >
        <div>
          <div style="font-size: 30px">精选文章</div>
          <span style="font-size: 12px">INTRODUCE</span>
          <div class="line"></div>
        </div>
        <el-row
          style="display: flex; flex-direction: column; align-items: center"
        >
          <el-col
            ><div class="grid-content ep-bg-purple" />
            <img style="width: 100%" src="@/assets/16.jpg" alt="Element logo" />
          </el-col>
          <el-col
            style="
              padding: 0 5px;
              text-align: left;
              background: #0f0f0f;
              line-height: 25px;
              height: auto;
              font-size: 12px;
              display: flex;
              flex-direction: column;
              align-items: center;
            "
            ><div class="grid-content ep-bg-purple-light" />

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <el-button
              type="danger"
              size="large"
              style="
                padding: 12px 55px;
                background: #ce0203;
                border: #ce0203;
                width: 60%;
              "
              >查看详情 »</el-button
            >
          </el-col>
        </el-row>
      </div>
      <!--  -->

      <div
        style="background: #0f0f0f; margin-top: 20px"
        v-for="(item, index) in 2"
        key="index"
      >
        <el-row
          style="
            text-align: left;
            background: #0f0f0f;
            line-height: 25px;
            display: flex;
            align-items: center;
            min-width: 412px;
            padding: 0 10px;
          "
        >
          <el-col :span="5"
            ><div class="grid-content ep-bg-purple" />
            <img
              style="width: 100%"
              src="@/assets/奖杯.png"
              alt="Element logo"
            />
          </el-col>
          <el-col
            style="
              text-align: left;
              line-height: 25px;
              color: #fff;
              font-size: 12px;
              width: 100%;
            "
          >
            <div style="display: flex; align-items: center">
              <div style="font-size: 18px">自由挑战赛(实盘)</div>
              <span
                style="
                  border: 1px solid #d10005;
                  color: #d10005;
                  font-size: 10px;
                  line-height: 16px;
                "
              >
                进行中
              </span>
            </div>
            <div
              style="border-bottom: 1px #4f4f4f solid; width: 100%; height: 1px"
            ></div>
            <p>
              比赛简介:自由实盘挑战赛由冠融科技主办，多家经纪商协办，比赛目的是通过实盘挑战赛方式为操盘手提供展示技术实力和学习
            </p>
            <p>
              周周奖是2020年冠融科技打造的专业外汇操盘手挑战赛事，将面向全球邀请外汇操盘手进行参赛，专为操盘手提供展示技术实力和学习交流的比赛平台。大赛秉承“发现优秀操盘手，合作互惠互利”的目的，坚持公平、公正、公开的原则，旨在深入挖掘可以实现稳定盈利的优秀操盘手，为代理商和资管公司选拔操盘手提供一条龙服务。
            </p>
            <p>
              周周奖由冠融科技主办，联合全球各大知名外汇经纪商进行赞助和协办。比赛分为模拟挑战赛和实盘挑战赛，比赛长期进行，每场比赛的周期为一个自然周，每场比赛的比赛规则和奖励都有可能不一样，比赛结束后将会进行比赛排名的审核和奖励发放。
            </p>
            <div
              style="
                float: right;
                display: flex;
                align-items: center;
                margin-top: 30px;
              "
            >
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                "
              >
                <span style="font-size: 40px">633</span>
                <div>报名人数</div>
              </div>
              <el-button
                type="danger"
                size="large"
                style="
                  background: #ce0203;
                  border: #ce0203;
                  --el-button-size: 23px;
                  font-size: 12px;
                  margin-left: 10px;
                "
                >立即报名 »</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </MqResponsive>
  <!-- 以上手机端 -->
  <MqResponsive target="md+">
    <div class="block text-center" style="height: 505px; width: 100%">
      <el-carousel height="auto" autoplay>
        <el-carousel-item style="height: 505px">
          <img
            src="@/assets/chaojiao/主营业务.png"
            alt=""
            class="banner-image"
            style="width: 100%"
          />
        </el-carousel-item>
      </el-carousel>
    </div>

    <div style="width: 1200px; margin: 30px auto">
      <el-tabs
        :stretch="true"
        v-model="category_id"
        class="demo-tabs"
        @tab-click="handleClick"
      >
        <el-tab-pane
          v-for="(item, index) in CategoryList"
          :key="index"
          :label="lang == '中文' ? item.name_cn : item.name_en"
          :name="item.id"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <div
      style="
        width: 1200px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
      "
    >
      <div style="width: 1200px">
        <div
          style="display: flex; text-align: left"
          v-for="item in bannerList"
          :key="item.id"
        >
          <idv
            ><span
              style="font-size: 28px; font-weight: 600; margin-bottom: 20px"
              >{{ lang == "中文" ? item.name_cn : item.name_en }}</span
            >
            <div
              style="font-size: 12px; width: 50%; overflow-y: auto"
              v-html="lang == '中文' ? item.content_cn : item.content_en"
            ></div
          ></idv>
        </div>
      </div>
    </div>

    <div
      style="width: 100%; display: flex; justify-content: end; align-items: end"
    >
      <div style="width: 60%; z-index: -1; margin-bottom: 4px">
        <el-row :gutter="350" class="row01">
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/名师.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("金融人才教育培训") }}
            </div></el-col
          >
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/区域.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("全国各地发展") }}
            </div></el-col
          >
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/金融产品.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("各类主流金融产品") }}
            </div></el-col
          >
        </el-row>
      </div>
      <div style="width: 850px; margin-right: -100px">
        <img
          src="@/assets/chaojiao/未标题-1.png"
          alt=""
          class="banner-image"
          style="width: 100%"
        />
      </div>
    </div>

    <!-- <div
      style="
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          height: 490px;
          position: relative;
        "
      >
        <div
          style="
            display: flex;
            flex-direction: column;
            text-align: left;
            width: 70%;
            margin-left: 285px;
            padding: 0 25px 0 0;
            box-sizing: border-box;
            margin-top: 60px;
          "
        >
          <span style="color: #4546f8; font-size: 18px; margin-bottom: 40px"
            >公司简介/company profile</span
          >
          <span
            style="font-size: 28px; font-weight: 600; margin-bottom: 20px"
            >{{
              lang == "中文" ? bannerList.name_cn : bannerList.name_en
            }}</span
          >
          <div style="font-size: 12px; line-height: 2.5">
            {{ lang == "中文" ? bannerList.notes_cn : bannerList.notes_en }}
          </div>
        </div>
        <div
          style="
            background: #3b3b3b;
            position: absolute;
            width: 1080px;
            bottom: 0;
            display: flex;
            justify-content: center;
            box-sizing: border-box;
            background-image: linear-gradient(to right, #363636, #595959);
            height: 120px;
            z-index: 0;
          "
          class="parent"
        >
          <div
            style="
              position: absolute;
              z-index: 5;
              display: flex;
              justify-content: space-around;
              top: 0;
              width: 55%;
              bottom: 0;
              padding: 10px 0;
            "
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100px;
                justify-content: space-around;
              "
            >
              <img
                :src="Server.url + bannerList.url"
                alt=""
                class="banner-image"
                style="width: 60px"
              />
              <span style="color: #fff; font-size: 12px">金融人才教育培训</span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100px;
                justify-content: space-around;
              "
            >
              <img
                src="@/assets/chaojiao/区域.png"
                alt=""
                class="banner-image"
                style="width: 60px"
              />
              <span style="color: #fff; font-size: 12px">全国各地发展</span>
            </div>
            <div
              style="
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 100px;
                justify-content: space-around;
              "
            >
              <img
                src="@/assets/chaojiao/金融产品.png"
                alt=""
                class="banner-image"
                style="width: 60px"
              />
              <span style="color: #fff; font-size: 12px">各类主流金融产品</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <img
          src="@/assets/chaojiao/未标题-1.png"
          alt=""
          class="banner-image"
          style="
            width: 850px;
            text-align: right;
            margin-right: -80px;
            position: relative;
            z-index: 5;
          "
        />
      </div>
    </div> -->

    <!-- <el-row
      :gutter="10"
      style="
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        position: relative;
        align-items: end;
        margin-top: 100px;
      "
    >
      <el-col
        :xs="4"
        :sm="6"
        :md="8"
        :lg="8"
        :xl="8"
        style="
          display: flex;
          flex-direction: column;
          text-align: left;
          width: 70%;
          margin-left: 285px;
          padding: 0 25px 0 0;
          box-sizing: border-box;
          margin-top: 20px;
          height: 520px;
        "
      >
        <div class="grid-content ep-bg-purple" />
        <span style="font-size: 28px; font-weight: 600; margin-bottom: 20px">{{
          lang == "中文" ? bannerList.name_cn : bannerList.name_en
        }}</span>
        <div style="font-size: 12px; line-height: 1.5">
          {{ lang == "中文" ? bannerList.notes_cn : bannerList.notes_en }}
        </div>
      </el-col>
      <el-col :xs="4" :sm="6" :md="8" :lg="13" :xl="11">
        <div class="grid-content ep-bg-purple-light" />
        <div>
          <img
            src="@/assets/chaojiao/未标题-1.png"
            alt=""
            class="banner-image"
            style="
              width: 100%;
              margin-right: -150px;
              text-align: right;
              position: relative;
              z-index: 5;
              right: 55px;
              bottom: -5px;
            "
          />
        </div>
      </el-col>
      <el-col
        :xs="4"
        :sm="6"
        :md="8"
        :lg="16"
        :xl="11"
        style="position: absolute"
      >
        <div class="grid-content ep-bg-purple" />
        <el-row :gutter="150" class="row01">
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/名师.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("金融人才教育培训") }}
            </div></el-col
          >
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/区域.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("全国各地发展") }}
            </div></el-col
          >
          <el-col :xs="4" :sm="6" :md="6" :lg="6" :xl="6"
            ><div class="grid-content ep-bg-purple" />
            <img
              src="@/assets/chaojiao/金融产品.png"
              alt=""
              class="banner-image"
              style="width: 50px"
            />
            <div style="width: 200px; margin-top: 10px">
              {{ $t("各类主流金融产品") }}
            </div></el-col
          >
        </el-row>
      </el-col>
    </el-row> -->

    <!-- <div
      style="
        width: 100%;
        margin-top: 40px;
        display: flex;
        height: 360px;
        background: #213485;
        color: #fff;
        justify-content: space-around;
        align-items: center;
        padding: 0 50px 0 100px;
        box-sizing: border-box;
      "
    >
      <div
        style="
          display: flex;
          flex-direction: column;
          text-align: left;
          line-height: 1.8;
        "
      >
        <span>CONTACT US</span>
        <span>{{ $t("联系我们") }}</span>
        <span>{{ $t("广州超交市场咨询服务有限公司") }}</span>
        <span>{{ $t("联系人") }}:李定潮</span>
        <span>{{ $t("手机") }}:18310090624</span>
        <span>{{ $t("邮箱") }}:617935071@q9.com</span>
        <span>{{ $t("地址") }}:广州市白云区石井街石潭路132号三层D5049</span>
      </div>

      <div style="display: flex">
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            justify-content: space-around;
          "
        >
          <span>李定潮</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:18310090624</span>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            color: #fff;
            justify-content: space-around;
          "
        >
          <span>客服晓云</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:15677134167</span>
        </div>
        <div
          style="
            display: flex;
            flex-direction: column;
            align-items: center;
            height: 240px;
            font-size: 18px;
            color: #fff;
            justify-content: space-around;
          "
        >
          <span>甘翠静</span>
          <img src="@/assets/chaojiao/了解更多.jpg" style="width: 60%" />
          <span>{{ $t("电话") }}:17372137306</span>
        </div>
      </div>
    </div> -->
  </MqResponsive>
  <div><Footer /></div>
</template>

<script setup>
import Footer from "../Footer";
import { reactive, ref } from "vue";
import MyServerHttp from "../../plugins/http.js";
import Server from "../../plugins/server.js";
import apiServe from "../../plugins/api.js";
const handleClick = (tab, event) => {
  console.log(tab.props.name);
  data.category_id = tab.props.name;
  getList(data);
};

let lang = ref("");
if (!localStorage.getItem("lang")) {
  lang = "中文";
} else {
  lang = localStorage.getItem("lang");
}
const category_id = ref("");
const CategoryList = ref([]);

const getCategoryList = async () => {
  const data = reactive({
    keyword: "",
    status: "2",
    page: 1,
    limit: 15,
  });
  try {
    const response = await MyServerHttp.post(
      apiServe.aboutUsCategoryList,
      data
    );
    CategoryList.value = response.data.datas.list.data;
    category_id.value = CategoryList.value[0].id;
    data.category_id = CategoryList.value[0].id;
    getList(data);
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
getCategoryList();

const bannerList = ref([]);
const data = reactive({
  keyword: "",
  status: "",
  page: 1,
  limit: 15,
  category_id: "",
});
const getList = async (data) => {
  try {
    const response = await MyServerHttp.post(apiServe.aboutUsList, data);
    bannerList.value = response.data.datas.list;
  } catch (error) {
    console.error("Fetch error:", error);
  }
};
</script>

<style scoped lang="less">
.text-center {
  overflow-y: hidden;
}

.carousel-item {
  color: #475669;
  opacity: 0.75;
  margin: 0;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  opacity: 0.75;
  display: flex;
  align-items: center;
  margin: 0;
  text-align: center;
  height: 100%;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.container {
  width: 1200px;
  margin: 80px auto 0;
  color: #fff;

  div {
    width: 100%;
  }
  h1 {
    font-size: 40px;
    line-height: 0px;
  }
  span {
    font-size: 16px;
  }
  .line {
    width: 80%;
    height: 1px;
    background: #8d0100;
    margin: 10px auto 30px;
  }
}

/deep/.el-table th.el-table__cell {
  background-color: var(--el-table-header-bg-color);
  background: #910101;
  border-bottom: none;
}
/deep/.el-table tr {
  background-color: var(--el-table-tr-bg-color);
  background: black;
}
/deep/.el-table--striped
  .el-table__body
  tr.el-table__row--striped
  td.el-table__cell {
  background: var(--el-fill-color-lighter);
  background: #1c1c1c;
}
/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: none;
}

.el-link {
  --el-link-font-size: var(--el-font-size-base);
  --el-link-font-weight: var(--el-font-weight-primary);
  /* --el-link-text-color: var(--el-text-color-regular); */
  /* --el-link-hover-text-color: var(--el-color-primary); */
  /* --el-link-disabled-text-color: var(--el-text-color-placeholder); */
  align-items: center;
  color: var(--el-link-text-color);
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-size: var(--el-link-font-size);
  font-weight: var(--el-link-font-weight);
  justify-content: center;
  outline: none;
  padding: 0;
  position: relative;
  text-decoration: none;
  vertical-align: middle;
}
.business {
  background: #fff;
  height: 350px;
  width: 190px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  box-sizing: border-box;
  justify-content: space-between;
}
.business-col {
  /* background: rgba(25, 21, 142, 37); */
  /* background: #3f3bc5; */
  color: #fff;
  background-image: url("@/assets/chaojiao/期权.png");
  background-size: cover; /* 或者使用 100% 100% */
  background-position: center; /* 确保图片居中 */
  background-repeat: no-repeat; /* 防止图片重复 */
}

.row01 {
  background: #3b3b3b;
  padding: 10px 30% 10px 30%;
  width: 150%;
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  color: #fff;
  font-size: 12px;
  box-sizing: border-box;
  .el-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }
}

.demo-tabs > .el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}
</style>
